import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router';

import { loginActions } from 'saga/auth/ducks';

import { store } from 'helpers/store/configureStore';

const renderMergedProps = (component: any, props: any, customProps: any, ...rest: any) => {
  return React.createElement(component, {
    props: props,
    customProps: customProps,
    ...rest,
  });
};

const ProtectedRoute = ({ loginAction, component, isInternal, customProps, ...rest }: DispatchToProps & any) => {
  const userHasRequiredPermissions = () => {
    const storeState = store.getState();

    return storeState.auth.userInfo?.logged && (!isInternal || storeState.auth.userInfo?.internal);
  };

  const redirectToLogin = () => {
    loginAction();

    return null;
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        userHasRequiredPermissions() ? renderMergedProps(component, props, customProps, rest) : redirectToLogin()
      }
    />
  );
};

interface DispatchToProps {
  loginAction: () => void;
}

const mapDispatchToProps: DispatchToProps = {
  loginAction: loginActions.request,
};

export default connect(null, mapDispatchToProps)(ProtectedRoute);
